import { render, staticRenderFns } from "./cartItem.vue?vue&type=template&id=0b5ffdfe&scoped=true"
import script from "./cartItem.vue?vue&type=script&lang=js"
export * from "./cartItem.vue?vue&type=script&lang=js"
import style0 from "./cartItem.vue?vue&type=style&index=0&id=0b5ffdfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5ffdfe",
  null
  
)

export default component.exports